import { AxiosError } from "axios";

import api from "services/api";
import { routers_constants } from "services/constants";
import { IBaseRestAPIResponse } from "services/interface";

interface IUserCustomerAuthenticationReturn {
  changePassword: (data: IUserCustomerAuthenticationChangePass) => Promise<any>;
  forgotPassword: (data: IUserCustomerAuthenticationEntryData) => Promise<any>;
}

interface IUserCustomerAuthenticationEntryData {
  email: string;
  plataform: number;
}

interface IUserCustomerAuthenticationChangePass {
  guid: string;
  password: string;
  oldPassword?: string;
  forgottenPassword?: boolean;
}

export const userCustomerAuthenticationServices: IUserCustomerAuthenticationReturn =
  {
    changePassword: async ({
      guid,
      password,
      oldPassword,
      forgottenPassword = false,
    }: IUserCustomerAuthenticationChangePass) => {
      try {
        const uri = routers_constants.userCustomerAuthentication.changePassword;
        const body = {
          guid: guid,
          password: password,
          ...(oldPassword && { oldPassword }),
          ...(forgottenPassword && { forgottenPassword }),
        };

        const { data, status } = await api.post<IBaseRestAPIResponse>(
          uri,
          body,
        );
        return { data, status };
      } catch (error) {
        const errorReturn = error as AxiosError;
        const { data, status } = errorReturn.response as IBaseRestAPIResponse;
        return { data, status };
      }
    },
    forgotPassword: async ({
      email,
      plataform,
    }: IUserCustomerAuthenticationEntryData) => {
      try {
        const uri = routers_constants.userCustomerAuthentication.forgotPassword;
        const body = {
          email: email,
          plataform: plataform,
        };

        const { data, status } = await api.post<IBaseRestAPIResponse>(
          uri,
          body,
        );
        return { data, status };
      } catch (error) {
        const errorReturn = error as AxiosError;

        if (errorReturn.response) {
          const { data, status } = errorReturn.response;
          return { data, status };
        } else {
          return error;
        }
      }
    },
  };
